import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppService } from '../../app.service';
import 'rxjs/add/operator/map'


@Injectable()
export class StoreService {
    private serviceURI = 'bireports/';
    constructor(private apiservice :AppService) {
    }
    getStoreView(): Observable<any[]> {
        return this.apiservice.post(`${this.serviceURI}storeview`,{
            "year": "2017",
            "month" :"1",
            "store" : "Clifton"
        });
    }
    getStoreDetails(year: string,month : string, store : string): Observable<any[]> {
      
        return this.apiservice.post(`${this.serviceURI}storedetail`,JSON.stringify({ year, month, store }));
    }
    getStoreSummary(year: string): Observable<any[]> {
        
        return this.apiservice.post(`${this.serviceURI}summary`,{
            "year": year,
            "month" :"1",
            "store" : "Clifton"
        });
  
    }

}




// WEBPACK FOOTER //
// ./src/app/home-page/store-view/store-service.service.ts